module.exports = __webpack_public_path__ + "static/media/question.c02cefcf.png";